export interface Character {
  id: string;
  name: string;
  role: string;
  age: string;
  personality: string;
  intro: string;
  tags: string[];
  image: string;
}

export interface CpItem {
  id: string;
  name: string;
  members: string;
  tag: string;
  tagColor: string;
  summary: string;
  points: string[];
  image: string;
}

export interface TimelineItem {
  chapter: string;
  title: string;
  desc: string;
}

export interface FqItem {
  q: string;
  a: string;
}

export const navLinks = [
  { id: "home", label: "首页" },
  { id: "characters", label: "角色图鉴" },
  { id: "cps", label: "CP关系" },
  { id: "timeline", label: "感情线" },
  { id: "guide", label: "追漫指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { num: "120+", label: "登场角色" },
  { num: "380+", label: "章节解析" },
  { num: "16", label: "热门CP" },
  { num: "50万+", label: "粉丝阅读" },
];

export const characters: Character[] = [
  {
    id: "su-wanqing",
    name: "苏晚晴",
    role: "女主",
    age: "20岁",
    personality: "外柔内刚",
    intro: "「恋爱辅助器」测试版的第一位内测用户，性格看似温柔腼腆，实则内心坚定有主见。在一次偶然中捡到辅助器，却意外卷入一段改写命运的感情线索，是整条感情线的核心起点。",
    tags: ["外柔内刚", "内测用户", "成长型女主"],
    image: "https://lovelinez.github.io/api/search-image?query=soft%20pastel%20anime%20girl%20portrait%20with%20gentle%20smile%2C%20long%20dark%20hair%2C%20cream%20blush%20background%2C%20romantic%20warm%20lighting%2C%20delicate%20lineart%2C%20clean%20minimal%20composition%2C%20dreamy%20youthful%20atmosphere&width=600&height=800&seq=char-suwanqing&orientation=portrait",
  },
  {
    id: "lu-shhye",
    name: "陆时野",
    role: "男主",
    age: "21岁",
    personality: "傲娇毒舌",
    intro: "同校金融系学霸，表面高冷毒舌、对恋爱嗤之以鼻，实则是「恋爱辅助器」的实际开发者之一。他与苏晚晴从互相嫌弃到彼此靠近，一路误会与心动交织，是全作感情线最复杂的存在。",
    tags: ["傲娇学霸", "隐藏开发者", "口嫌体正直"],
    image: "https://lovelinez.github.io/api/search-image?query=cool%20handsome%20anime%20boy%20portrait%2C%20dark%20hair%20and%20sharp%20eyes%2C%20school%20uniform%20blazer%2C%20peach%20warm%20background%2C%20soft%20romance%20comic%20style%2C%20clean%20delicate%20lineart%2C%20youthful%20minimal%20composition&width=600&height=800&seq=char-lushhye&orientation=portrait",
  },
  {
    id: "gu-yanshen",
    name: "顾言深",
    role: "男二 · 天降系",
    age: "22岁",
    personality: "温柔腹黑",
    intro: "高年级学长兼学生会会长，待人温柔周到，是许多人眼中完美的存在。他对苏晚晴有着不为人知的执念，与主线CP形成激烈的天降与竹马之争，是感情线中最大的变数。",
    tags: ["温柔学长", "天降竹马", "隐藏执念"],
    image: "https://lovelinez.github.io/api/search-image?query=gentle%20handsome%20anime%20senior%20boy%20portrait%2C%20soft%20smile%2C%20glasses%2C%20warm%20beige%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20clean%20youthful%20minimal%20composition&width=600&height=800&seq=char-guyanshen&orientation=portrait",
  },
  {
    id: "lin-shuyao",
    name: "林舒窈",
    role: "女二 · 白月光",
    age: "21岁",
    personality: "知性优雅",
    intro: "艺术系人气女生，气质清冷、才华出众，是许多人心中遥不可及的白月光。她与陆时野有过一段模糊的过去，她的回归让本就胶着的感情线再度升温，也牵出更多隐秘真相。",
    tags: ["白月光", "艺术系才女", "身世谜团"],
    image: "https://lovelinez.github.io/api/search-image?query=elegant%20cool%20anime%20girl%20portrait%2C%20long%20light%20hair%2C%20artistic%20aura%2C%20cream%20mint%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20clean%20minimal%20composition&width=600&height=800&seq=char-linshuyao&orientation=portrait",
  },
  {
    id: "chen-zuo",
    name: "陈佐",
    role: "男三 · 竹马系",
    age: "20岁",
    personality: "阳光忠犬",
    intro: "苏晚晴青梅竹马的邻家男孩，性格阳光开朗，总在关键时刻默默守护。他把喜欢藏得很深，选择以朋友的身份陪在女主身边，是感情线中最令人心疼又温暖的存在。",
    tags: ["阳光竹马", "默默守护", "友情变亲情"],
    image: "https://lovelinez.github.io/api/search-image?query=cheerful%20sunny%20anime%20boy%20portrait%2C%20messy%20hair%20big%20smile%2C%20warm%20peach%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20youthful%20clean%20minimal%20composition&width=600&height=800&seq=char-chenzuo&orientation=portrait",
  },
  {
    id: "tang-yixin",
    name: "唐艺昕",
    role: "闺蜜",
    age: "20岁",
    personality: "元气助攻",
    intro: "苏晚晴最好的闺蜜，也是全校知名的恋爱小百科。她既是感情线的最佳助攻手，也常常一针见血地点破男女主之间的心动细节，被粉丝称为「最强嘴替」。",
    tags: ["元气闺蜜", "最强助攻", "恋爱百科"],
    image: "https://lovelinez.github.io/api/search-image?query=energetic%20cute%20anime%20girl%20portrait%2C%20twin%20ponytails%20bright%20smile%2C%20soft%20pink%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20clean%20minimal%20youthful%20composition&width=600&height=800&seq=char-tangyixin&orientation=portrait",
  },
];

export const cpList: CpItem[] = [
  {
    id: "wanqing-yeh",
    name: "晴野CP",
    members: "苏晚晴 × 陆时野",
    tag: "主线CP",
    tagColor: "primary",
    summary: "全作当之无愧的官配主线。从互看不顺眼的冤家，到默契十足的灵魂伴侣，两人在一次次误会与和解中逐渐靠近，是感情线最完整也最令人心动的一对。",
    points: ["初始互怼 · 欢喜冤家开局", "图书馆偶遇 · 心动萌芽", "身份揭露 · 信任危机", "双向奔赴 · 官宣高甜"],
    image: "https://lovelinez.github.io/api/search-image?query=two%20anime%20characters%20standing%20close%20under%20cherry%20blossom%20tree%2C%20boy%20and%20girl%20facing%20each%20other%20shyly%2C%20warm%20pink%20romantic%20background%2C%20soft%20pastel%20comic%20style%2C%20delicate%20lineart%2C%20dreamy%20youthful%20atmosphere&width=800&height=500&seq=cp-wanqingyeh&orientation=landscape",
  },
  {
    id: "wanqing-yanshen",
    name: "深晴CP",
    members: "苏晚晴 × 顾言深",
    tag: "天降CP",
    tagColor: "accent",
    summary: "温柔学长对女主的守护式爱意，带着天降的浪漫滤镜。顾言深的存在让感情线充满张力，也让无数粉丝为「温柔乡」与「毒舌学神」之间的选择争论不休。",
    points: ["学生会初遇 · 温柔关照", "天台告白 · 心意袒露", "身世反转 · 立场对撞"],
    image: "https://lovelinez.github.io/api/search-image?query=gentle%20anime%20senior%20offering%20a%20book%20to%20a%20shy%20girl%20on%20a%20school%20rooftop%2C%20sunset%20warm%20glow%2C%20soft%20peach%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20dreamy%20atmosphere&width=800&height=500&seq=cp-wanqingyanshen&orientation=landscape",
  },
  {
    id: "yeh-shuyao",
    name: "时光CP",
    members: "陆时野 × 林舒窈",
    tag: "往事CP",
    tagColor: "secondary",
    summary: "陆时野与林舒窈之间模糊不清的过往，既是感情的悬念，也是全作伏笔最深的线。白月光回归引发误会升级，让晴野CP迎来最大的情感考验。",
    points: ["钢琴室回忆 · 青梅旧事", "误会升级 · 冷战危机", "真相揭开 · 释然放下"],
    image: "https://lovelinez.github.io/api/search-image?query=anime%20boy%20at%20piano%20and%20girl%20watching%20from%20window%2C%20mint%20and%20cream%20toned%20background%2C%20nostalgic%20romantic%20comic%20style%2C%20soft%20lighting%2C%20delicate%20lineart%2C%20dreamy%20melancholic%20atmosphere&width=800&height=500&seq=cp-yehshuyao&orientation=landscape",
  },
  {
    id: "wanqing-zuo",
    name: "佐晴CP",
    members: "苏晚晴 × 陈佐",
    tag: "竹马CP",
    tagColor: "accent",
    summary: "青梅竹马的默默守护，是所有感情线里最纯粹也最温柔的存在。陈佐选择以朋友身份陪伴，把喜欢藏在日常里，让人心疼又忍不住为他打call。",
    points: ["童年约定 · 青梅两小", "默默守护 · 藏在细节", "释然祝福 · 温柔放手"],
    image: "https://lovelinez.github.io/api/search-image?query=childhood%20friends%20anime%20boy%20and%20girl%20walking%20home%20together%20under%20street%20lights%2C%20warm%20peach%20evening%20background%2C%20nostalgic%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20soft%20dreamy%20atmosphere&width=800&height=500&seq=cp-wanqingzuo&orientation=landscape",
  },
];

export const timeline: TimelineItem[] = [
  { chapter: "第1-20话", title: "相遇 · 冤家开局", desc: "苏晚晴捡到「恋爱辅助器」，却意外惹上高冷学霸陆时野。两人在社团与课堂间不断斗嘴，命运的齿轮开始悄悄转动。" },
  { chapter: "第21-45话", title: "心动 · 暧昧萌芽", desc: "图书馆偶遇、雨天共伞、校庆合作……一次次日常相处让两人关系破冰，陆时野的毒舌之下藏着越来越多藏不住的心动。" },
  { chapter: "第46-70话", title: "拉扯 · 误会升级", desc: "林舒窈回归、顾言深介入，感情线进入最胶着的拉扯期。信任危机爆发，晴野CP迎来相识以来最激烈的冷战。" },
  { chapter: "第71-95话", title: "揭示 · 双向奔赴", desc: "身世真相与辅助器秘密逐一揭开，两人终于坦诚心意。在漫天樱花下，主线CP迎来属于他们的双向奔赴。" },
  { chapter: "第96话-至今", title: "官宣 · 甜蜜日常", desc: "确认关系后开启高甜日常，同时新的支线CP与伏笔不断展开，感情线仍在持续升温中。" },
];

export const guideItems = [
  {
    id: "j1",
    tag: "入坑指南",
    icon: "ri-compass-3-line",
    title: "新手入坑先看这篇",
    desc: "一篇看懂人物关系、主线CP走向与世界观设定，帮你快速进入剧情，不再脸盲。",
  },
  {
    id: "j2",
    tag: "主线解析",
    icon: "ri-heart-pulse-line",
    title: "晴野CP感情线全梳理",
    desc: "从欢喜冤家到双向奔赴，按章节逐段拆解男女主心动的每一个关键节点。",
  },
  {
    id: "j3",
    tag: "伏笔考据",
    icon: "ri-search-eye-line",
    title: "恋爱辅助器秘密大考据",
    desc: "辅助器的来历、开发者身份与隐藏设定，结合细节逐帧考据，挖出作者埋下的伏笔。",
  },
  {
    id: "j4",
    tag: "配角图鉴",
    icon: "ri-team-line",
    title: "配角关系与支线CP",
    desc: "竹马、白月光、助攻闺蜜……盘点配角背后的故事与不断展开的支线感情线。",
  },
  {
    id: "j5",
    tag: "热门CP",
    icon: "ri-flashlight-line",
    title: "TOP人气CP排行榜",
    desc: "晴野、深晴、时光、佐晴谁最火？结合粉丝讨论热度盘点人气CP的吸粉秘诀。",
  },
  {
    id: "j6",
    tag: "追更日历",
    icon: "ri-calendar-check-line",
    title: "更新进度与追更攻略",
    desc: "整理漫画更新节奏、单行本与相关衍生内容，让你不错过任何一次更新。",
  },
];

export const faqs: FqItem[] = [
  { q: "「恋爱辅助器」漫画讲的是什么故事？", a: "故事围绕女主角苏晚晴偶然捡到一款名为「恋爱辅助器」的神秘设备展开。它在为她「指点」恋爱的同时，也让她与高冷学霸陆时野之间发生了一系列误会与心动。作品将校园日常、情感拉扯与一点点悬疑伏笔巧妙结合，是目前很受关注的青春恋爱题材漫画。" },
  { q: "主线CP是哪一对？", a: "主线CP是「晴野CP」，即女主角苏晚晴与男主角陆时野。两人的感情线从互相嫌弃的欢喜冤家开始，历经暧昧、误会与信任危机，最终走向双向奔赴，是全作最完整、最令人心动的一段感情。" },
  { q: "有哪些值得关注的其他CP？", a: "除了主线晴野CP外，还有温柔守护的天降CP「深晴CP」（顾言深×苏晚晴）、充满悬念的往事CP「时光CP」（陆时野×林舒窈），以及最令人心疼的竹马CP「佐晴CP」（陈佐×苏晚晴），每一对的感情线都各有看点。" },
  { q: "男主陆时野和「恋爱辅助器」是什么关系？", a: "陆时野是「恋爱辅助器」的实际开发者之一。他表面抗拒恋爱，却在开发设备的过程中不断接近女主，这也成为整条感情线中最关键的伏笔与反转点之一。" },
  { q: "在哪里可以追更这部漫画？", a: "漫画目前在各主流漫画平台连载更新，具体上架平台与更新频率以官方为准。建议关注官方发布渠道，或在本站「追漫指南」栏目查看更新进度与相关内容整理。" },
  { q: "感情线目前进展到哪一阶段？", a: "按最新连载进度，主线晴野CP已确认关系进入高甜日常阶段，同时新的支线CP与隐藏伏笔正在逐步展开，感情线仍在持续升温。" },
];

export const recommendations = [
  { id: "r1", title: "晴野CP十大心动瞬间盘点", desc: "从图书馆偶遇到樱花树下告白，细数主线CP最让人尖叫的名场面。", time: "6分钟", image: "https://lovelinez.github.io/api/search-image?query=anime%20couple%20moment%20under%20sakura%20blossoms%2C%20soft%20warm%20pink%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20dreamy%20youthful%20atmosphere&width=600&height=400&seq=rec-r1&orientation=landscape" },
  { id: "r2", title: "「恋爱辅助器」到底是什么？", desc: "深入考据辅助器的来历、开发者与隐藏设定，一次性看懂最核心的伏笔。", time: "8分钟", image: "https://lovelinez.github.io/api/search-image?query=mysterious%20glowing%20gadget%20device%20on%20open%20book%2C%20warm%20cream%20background%2C%20magical%20romance%20comic%20style%2C%20soft%20lighting%2C%20delicate%20lineart&width=600&height=400&seq=rec-r2&orientation=landscape" },
  { id: "r3", title: "配角天团：竹马与白月光的故事", desc: "陈佐的默默守护、林舒窈的回归之谜，配角线同样精彩到让人停不下来。", time: "5分钟", image: "https://lovelinez.github.io/api/search-image?query=three%20anime%20characters%20silhouette%20at%20sunset%20school%20gate%2C%20warm%20peach%20background%2C%20romantic%20comic%20style%2C%20delicate%20lineart%2C%20dreamy%20atmosphere&width=600&height=400&seq=rec-r3&orientation=landscape" },
  { id: "r4", title: "五大冷门伏笔，细思极恐", desc: "那些你可能漏掉的细节，作者早已埋好了通往结局的线索。", time: "7分钟", image: "https://lovelinez.github.io/api/search-image?query=close%20up%20anime%20detail%20of%20hands%20and%20secret%20notes%2C%20mint%20and%20cream%20background%2C%20mystery%20romance%20comic%20style%2C%20soft%20lighting%2C%20delicate%20lineart&width=600&height=400&seq=rec-r4&orientation=landscape" },
];